/* eslint-env browser */

class UriHelper { // eslint-disable-line no-unused-vars
  static parseQueryParams() {
    if (!window.location.search) {
      return [];
    }
    return window.location.search.split('?')[1].split('&').map((queryParam) => {
      const [name, value] = queryParam.split('=');
      return {
        name,
        value: decodeURIComponent(value),
      };
    });
  }

  static setQueryParams(params = []) {
    const queryStr = `?${params.map(oneParam => `${oneParam.name}=${encodeURIComponent(oneParam.value)}`).join('&')}`;
    window.location.assign(`${window.location.protocol}//${window.location.host}${window.location.pathname}${queryStr}`);
  }
  static setQueryStr(params = []) {
    return `${params.map(oneParam => `${oneParam.name}=${encodeURIComponent(oneParam.value)}`).join('&')}`;
  }
}
export default UriHelper;
